import { z } from 'zod';

import { isoDateTimeSchema, uuidSchema } from './common.js';

export const clientSchema = z.object({
  id: uuidSchema,
  /** Public numeric id — used in browser URLs (/companies/100000042). */
  number: z.number().int().positive(),
  name: z.string().min(1).max(200),
  pinned: z.boolean(),
  sortOrder: z.number().int(),
  archived: z.boolean(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});
export type ClientDto = z.infer<typeof clientSchema>;

export const createClientSchema = z.object({
  name: z.string().min(1, 'Введите название компании').max(200),
  pinned: z.boolean().optional(),
});
export type CreateClientDto = z.infer<typeof createClientSchema>;

export const updateClientSchema = z
  .object({
    name: z.string().min(1).max(200),
    pinned: z.boolean(),
    sortOrder: z.number().int(),
    archived: z.boolean(),
  })
  .partial();
export type UpdateClientDto = z.infer<typeof updateClientSchema>;
